import PropTypes from 'prop-types';
import { PageHeader } from '@evertrue/et-components';
import AddTaskButton from './create/add-task-button';
import TasksActionMenu from './tasks-action-menu';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';

/**
 * TasksHeader displays the page header for tasks pages.
 * Supports both manual and automated task views.
 */
const TasksHeader = ({
  userType,
  bulkSelectedTasks,
  selectedDueDate,
  emptyState = false,
  hasBulkTaskMoves,
  resetBulkSelect = () => {},
  refreshTasks = () => {},
  taskType = 'manual',
}) => {
  const { flagEnabled: cadenceV2Enabled } = useFeatureFlag('cadenceV2Internal');

  const getHeaderContent = () => {
    if (taskType === 'automated') {
      return {
        title: 'Automated Tasks',
        subtitle: 'Tasks scheduled to run automatically from your cadences',
      };
    }
    if (!cadenceV2Enabled) {
      return { title: 'Tasks', subtitle: null };
    }
    // Check URL params for pre-selected task type filters
    const params = new URLSearchParams(window.location.search);
    const taskTypesParam = params.get('taskTypes');
    if (taskTypesParam) {
      const types = taskTypesParam.split(',');
      const hasCadence = types.includes('cadence_1') || types.includes('cadence_2');
      const hasNonCadence = types.includes('non_cadence');
      if (hasCadence && !hasNonCadence) {
        return {
          title: 'Cadence Tasks',
          subtitle: 'Tasks from your Cadence 1.0 and 2.0 workflows',
        };
      }
    }
    return {
      title: 'All Manual Tasks',
      subtitle: 'Tasks created by you or assigned to you',
    };
  };

  const { title, subtitle } = getHeaderContent();

  return (
    <div className="task-header-container">
      <PageHeader
        className={'task-header'}
        title={title}
        subtitle={subtitle}
        actions={
          !emptyState &&
          taskType === 'manual' && (
            <>
              <AddTaskButton userType={userType} />
              <TasksActionMenu
                selectedDueDate={selectedDueDate}
                bulkSelectedTasks={bulkSelectedTasks}
                hasBulkTaskMoves={hasBulkTaskMoves}
                resetBulkSelect={resetBulkSelect}
                refreshTasks={refreshTasks}
              />
            </>
          )
        }
      />
    </div>
  );
};

TasksHeader.propTypes = {
  userType: PropTypes.string,
  bulkSelectedTasks: PropTypes.array,
  selectedDueDate: PropTypes.string,
  emptyState: PropTypes.bool,
  hasBulkTaskMoves: PropTypes.bool,
  resetBulkSelect: PropTypes.func,
  refreshTasks: PropTypes.func,
  taskType: PropTypes.oneOf(['manual', 'automated']),
};

export default TasksHeader;
